<div *ngIf="modalOpened" class="modal-background"></div>
<!--  -->
<div *ngIf="!modalOpened" class="location-tile-list-container mb-3">
  <app-content-header text="Location"></app-content-header>
  <div *ngIf="selectedLocation" class="px-3 mb-4">
    <span class="oswald primary" style="font-size: 1.125rem">{{
      selectedLocation.name
    }}</span>
    <br />
    <span class="lato bold teal" style="font-size: 1.125rem">{{
      selectedLocation.address1 +
        " " +
      selectedLocation.address2
    }}</span>
    <br />
    <span class="lato teal" style="font-size: 0.813rem">{{
      selectedLocation.city +
        ", " +
      selectedLocation.state +
        " " +
        selectedLocation.zipcode
    }}</span>
    <br />
    <img
      src="assets/images/ico_phone_red.png"
      alt="Phone Icon"
      height="16"
      class="mr-1"
    />
    <a
      [href]="'tel:' + selectedLocation.telephone"
      class="link"
      (click)="callCamp()"
      >{{
      selectedLocation.telephone | phoneNumber
      }}</a
    >
  </div>

  <!-- Campers -->
  <app-content-header text="Camper(s)"></app-content-header>
  <div
    *ngFor="
      let pet of petList;
      let isLastChild = last
    "
    [ngClass]="{'last-child': isLastChild}"
  >
    <app-pet-tile-review [petInfo]="pet"></app-pet-tile-review>
  </div>

  <!-- Reservation Details -->
  <app-content-header text="Reservation Details"></app-content-header>

  <!-- Date -->
  <div class="row no-gutters price-text lato">
    <div class="col pr-3 font-weight-bold">Date</div>
  </div>
  <div
    class="text-sm"
    *ngIf="endDate; else singleDate"
  >
    {{ startDate }} - {{ endDate }}
  </div>
  <ng-template #singleDate>
    <div class="text-sm">{{ startDate }}</div>
  </ng-template>
  <div
    *ngFor="let pet of petList;"
  >
    <div class="row no-gutters price-text lato mt-3">
      <div class="service-tile-form-content col pr-3 font-weight-bold">
        {{ petNames[pet.id] }}
      </div>
    </div>
    <!-- Services -->
    <div *ngFor="let category of coreServices | keyvalue">
      <div *ngFor="let service of category.value">
          <div class="row no-gutters lato">
            <div class="col text-sm">{{ service.serviceName }} (${{ service.servicePrice }} x {{service.serviceQuantity}})</div>
            <div class="text-sm">${{service.servicePrice * service.serviceQuantity}}</div>
          </div>
      </div>
    </div>
    <!-- Add-ons -->
    <div *ngFor="let service of addonServices[pet.id]">
      <div class="row no-gutters lato">
        <div class="col text-sm">{{ service.serviceName }} (${{ service.servicePrice }} x {{service.serviceQuantity}})</div>
        <div class="text-sm">${{service.servicePrice * service.serviceQuantity}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="reservationNotes" class="row no-gutters price-text lato mt-3">
    <div class="service-tile-form-content col pr-3 font-weight-bold">
      Notes
    </div>
  </div>
  <div
    class="text-md"
    *ngIf="reservationNotes"
  >
    {{ reservationNotes}}
  </div>

  <hr class="view-divider" />


  <div class="row no-gutters lato">
    <div class="col pr-3 price-text">Estimated Total*</div>
    <div class="service-price total-text text-lg text-danger">
      ${{ total }}
    </div>
  </div>
  <div class="row no-gutters lato mb-3">
    <div class="col pr-3 text-sm disclaimer-text">* Taxes, fees, discounts and available packages are not included in subtotal and will be applied during checkout at Camp.
      Please be advised that boarding stays during holidays and other peak times may be subject to an additional nightly fee.
    </div>
  </div>
  <!-- add payment method -->
  <div *ngIf="hasBoardingServiceSelected && !hasPaymentMethod && isCcpEnabledInLocation" class="payment-method-container">
    <div class="credit-card-image-container">
      <img
        src="assets/svg/ico_notice_credit_card.svg"
        alt="Credit Card Required Icon"
        width="40"
        height="40"
      >
      <div class="reqired-text-style">
        A credit card is required for boarding reservation requests. Some Camps require deposits to hold confirmed reservations. Please check with Camp regarding specific deposit policies.
      </div>
    </div>
    <app-payment-details-form
      #paymentDetailForm
      [franchiseId]="reservationRequest.selectedLocation.id"
      (submittedInSuccess)="submittedInSuccess($event)"
      (submittedInFailure)="submittedInFailure($event)"
    ></app-payment-details-form>
    <div class="note-container">
      <div class="lato bold note-title">Please note:</div>
      <div class="note-description">No-shows, late cancellations and/or early check outs may be subject to a fee. Please check with Camp regarding these policies.</div>
    </div>
  </div>

  <!-- Button -->
  <hr class="view-divider" />
  <footer class="footer-action">
    <mat-checkbox
      *ngIf="isCcpEnabledInLocation && hasBoardingServiceSelected && !hasPaymentMethod"
      [checked]="checkboxConsent"
      (change)="toggleCheckbox()"
      style="margin-right: 0.625rem"
    >Yes, I understand this policy on boarding reservations</mat-checkbox>
    <button
      noDoubleClick
      class="btn btn-danger btn-block"
      [ngClass]="{'disabled-btn': !paymentFormValid}"
      [disabled]="(!paymentFormValid || !checkboxConsent) && (!hasPaymentMethod && hasBoardingServiceSelected && isCcpEnabledInLocation) "
      (debounceClick)="submitReservation()"
    >Submit Request</button>
  </footer>
</div>
